export default "__VITE_ASSET__OnThtPNI__"